export default {
  title: 'Adaugă fișier: {{slot}}',
  replace_title: 'Înlocuiește fișierul: {{slot}}',
  replace_description: 'Fișierul nou îl înlocuiește pe acesta. Păstrăm vechiul fișier în evidențele noastre.',
  form: {
    kind: {
      label: 'Tip de act de identitate',
      options: {
        passport: 'Pașaport',
        driver_license: 'Permis de conducere',
        id_card: 'Carte de identitate',
        residence_permit: 'Permis de ședere',
      },
    },
    front: {
      label: 'Față',
    },
    back: {
      label: 'Verso',
    },
    file: {
      label: 'Fișier',
    },
    expires_at: {
      label: 'Valabil până la',
      placeholder: 'Selectează o dată',
    },
    holder: {
      label: 'Al cui act de identitate este acesta?',
      options: {
        owner: 'Al meu, al proprietarului',
        partner: 'Al unui partener',
      },
    },
    holder_name: {
      label: 'Numele partenerului',
      placeholder: 'Prenume și nume',
    },
  },
  accepted_files: 'PDF, JPG sau PNG, până la {{max}} MB.',
  accepted_images_min: 'O fotografie trebuie să aibă cel puțin {{min}} KB.',
  errors: {
    file_type: 'Sunt acceptate doar fișiere PDF, JPG sau PNG.',
    file_too_large: 'Fișierul depășește {{max}} MB.',
    file_too_small: 'O fotografie trebuie să aibă cel puțin {{min}} KB.',
  },
  buttons: {
    select_file: 'Selectează fișier',
    submit: 'Încarcă',
    cancel: 'Anulează',
  },
  toasts: {
    success: 'Fișier încărcat',
    error: 'Fișierul nu a putut fi încărcat.',
  },
};
